"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPlainIconButton = exports.StyledIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fuseTappableArea = _interopRequireDefault(require("@tvg/fuse-tappable-area"));
var _fuseUtils = require("@tvg/fuse-utils");
var _fuseIconElement = _interopRequireDefault(require("@tvg/fuse-icon-element"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledPlainIconButton = exports.StyledPlainIconButton = _styledComponents["default"].button.attrs({
  className: 'fuse-plain-icon-button'
}).withConfig({
  displayName: "styled-plain-icon-button__StyledPlainIconButton",
  componentId: "sc-19qjghf-0"
})(["background:none;border:none;display:inline-flex;margin:0;padding:0;position:relative;&:active,&:focus{", "}&:hover,&:focus{color:var(--color-brand-dark);cursor:pointer;}&:active{color:var(--color-global-black);}&:focus .fuse-plain-icon-button__icon,&:hover .fuse-plain-icon-button__icon{background:var(--color-brand-dark);}&:active .fuse-plain-icon-button__icon{background:var(--color-global-black);}&[disabled]{color:var(--color-global-grey400);background-color:unset;border:none;cursor:auto;}&[disabled] .fuse-plain-icon-button__icon{background-color:var(--color-global-grey400);}", ""], _fuseUtils.FocusCss, _fuseTappableArea["default"]);
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(_fuseIconElement["default"]).attrs({
  className: 'fuse-plain-icon-button__icon',
  'data-testid': 'fuse-plain-icon-button-icon-test-id'
}).withConfig({
  displayName: "styled-plain-icon-button__StyledIcon",
  componentId: "sc-19qjghf-1"
})([""]);